import { render, staticRenderFns } from "./GPJSSZLR.vue?vue&type=template&id=534f1af0&scoped=true"
import script from "./GPJSSZLR.vue?vue&type=script&lang=js"
export * from "./GPJSSZLR.vue?vue&type=script&lang=js"
import style0 from "./GPJSSZLR.vue?vue&type=style&index=0&id=534f1af0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f1af0",
  null
  
)

export default component.exports